'use client';

import { useState } from 'react';
import Image from 'next/image';
import { Switch } from '@mantine/core';

import { Plans } from '@/components/(education)/plans/plans.component';

import { RichText } from '@/elements/rich-text/rich-text.component';

import {
  Container,
  Heading,
  Content,
  Description,
  Section,
  SubtitleWrap,
  Subtitle,
  Line,
  SwitchContainer,
  SwitchLabel,
} from './subscription.elements';

import { colors } from '@/styles/theme';

const Subscription = ({ subscription: { image, content, title }, plans }) => {
  const [dynamic, setDynamic] = useState('monthly');

  return (
    <Container>
      <Heading>
        {image ? (
          <Image
            src={image.url}
            width={1024}
            height={512}
            alt={image.alt}
            style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
          />
        ) : null}
      </Heading>
      <Content>
        <Description>
          <RichText content={content} />
        </Description>
        <Section>
          <SubtitleWrap>
            <Subtitle $caps $color="simba">
              Odaberi paket
            </Subtitle>
            <Line $color="simba" />
          </SubtitleWrap>
          {/* <Message>
              Želiš unaprijediti svoju prijavu s dodatnim značajkama? Odaberi neki od naprednijih
              paketa niže.
            </Message> */}
          {plans.length > 0 ? (
            <SwitchContainer>
              <SwitchLabel $active={dynamic === 'monthly'}>Mjesečno</SwitchLabel>
              <Switch
                size="lg"
                color={colors.brown}
                checked={dynamic === 'annual'}
                onChange={(e) => setDynamic(e.target.checked ? 'annual' : 'monthly')}
                withThumbIndicator={false}
              />
              <SwitchLabel $active={dynamic === 'annual'}>Godišnje</SwitchLabel>
            </SwitchContainer>
          ) : null}
          <Plans
            subscription={{ title }}
            subscriptionPlans={plans}
            // registration={}
            dynamic={dynamic}
          />
        </Section>
      </Content>
    </Container>
  );
};

export { Subscription };
